<script>
  export default {
    props: {
      value: {
        required: true,
      },
    },
  };
</script>

<template>
  <label
    class="form-checkbox"
    :class="{ 'form-checkbox--checked': value }"
    >

    <input
      type="checkbox"
      :checked="value"
      class="form-checkbox__control"
      @change="$emit('input', $event.target.checked)"
      >

    <slot />
  </label>
</template>

<style lang="scss">
  .form-checkbox {
    display: flex;
    line-height: 1;
    cursor: pointer;
    font-size: 13px;
    color: #b2b8c5;
    position: relative;
    align-items: center;
    margin-bottom: 24px;
    letter-spacing: .26px;

    &__control {
      display: none;
    }

    &__icon {
      margin-left: 8px;
    }

    &::before {
      width: 14px;
      content: '';
      height: 14px;
      background: none;
      margin-right: 12px;
      border-radius: 2px;
      display: inline-block;
      border: 1px solid #b2b8c5;
    }

    &--checked::after {
      top: 3px;
      left: 3px;
      width: 8px;
      content: '';
      height: 5px;
      position: absolute;
      border-left: 2px solid;
      border-bottom: 2px solid;
      transform: rotate(-45deg);
    }
  }
</style>
